import { __assign, __extends } from "tslib";
import React from 'react';
import ReactDOM from 'react-dom';
export var WithFocusIndicationHOC = function (init, WrappedComponent) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1(props) {
            var _this = _super.call(this, props) || this;
            _this.blurTimeoutId = null;
            _this.state = { isFocused: init };
            _this.onFocus = _this.onFocus.bind(_this);
            _this.onBlur = _this.onBlur.bind(_this);
            _this.setFocus = _this.setFocus.bind(_this);
            return _this;
        }
        class_1.prototype.onFocus = function () {
            if (this.blurTimeoutId) {
                clearTimeout(this.blurTimeoutId);
                this.blurTimeoutId = null;
            }
            this.setState({ isFocused: true });
        };
        class_1.prototype.onBlur = function () {
            var _this = this;
            this.blurTimeoutId = setTimeout(function () {
                _this.setState({ isFocused: false });
            });
        };
        class_1.prototype.setFocus = function (value) {
            this.setState({ isFocused: value });
            if (value === false) {
                var node = ReactDOM.findDOMNode(this);
                var inputBox = node.querySelector('.searchInput');
                if (inputBox) {
                    inputBox.blur();
                }
            }
        };
        class_1.prototype.render = function () {
            var newProps = __assign(__assign({}, this.props), { isFocused: this.state.isFocused, setFocus: this.setFocus });
            return (React.createElement("div", { tabIndex: 0, onFocus: this.onFocus, onBlur: this.onBlur, style: { width: 'fit-content', outline: 'none' } }, React.createElement(WrappedComponent, newProps)));
        };
        return class_1;
    }(React.Component));
};
export var WithFocusIndication = function (_a) {
    var init = (_a === void 0 ? { init: false } : _a).init;
    return function (component) {
        return WithFocusIndicationHOC(init, component);
    };
};
//# sourceMappingURL=with-focus-indication.js.map